export interface ThemeColors {
    primary: string; // Es el color más representativo de tu marca o interfaz. Se usa para resaltar lo más importante: botones primarios, enlaces activos, íconos clave, etc.
    primaryHover: string;
    secondary: string; // Color Pasivo - Un color complementario al primario, también usado para destacar elementos pero con menos jerarquía.
    secondaryHover: string;
    tertiary: string;
    tertiaryHover: string;
    cuaternary: string;
    cuaternaryHover: string;
    background: string; // Es el color que define la superficie donde se colocan los elementos. Puede variar según el modo (claro/oscuro).
    backgroundSecondary: string;
    backgroundCuaternary: string;
    backgroundQuinary: string;
    backgroundSextary: string;
    backgroundSeptary: string;
    backgroundOctary: string;
    backgroundNonary: string;
    text: string; //Color principal del texto.
    textPill1: string;
    textPill2: string;
    textPill3: string;
    textPill4: string;

    white:string;
    neutral:string;
    error: string; // Para mensajes de estado o alertas.
    errorPasivo: string,
    errorHover: string,
    informacion: string,

    Pasivo: string,
    Hover: string,
    // Hover: "#79DD8B", //verde Hover
    Activo: string,
    //Activo: "#42C67E",//verde
    //Gris
    Neutro: string,
    TitleGris: string,
    GrisClaro: string,
    //colores claros
    ClaroHover: string,
    Claro: string,
    //Alertas
  
    ErrorHoverClaro: string,
    Exito: string,
   
    InformacionFondo: string,
    //texto
    Title: string,
    TitleHover: string,
    //lINEA
    lineaModal: string,
    lineaTabla: string,
    //circulos
    Circular: string,
}

export interface ThemeApiResponse {
  theme: "light" | "dark";
  colors: ThemeColors;
}

export const defaultLightColors: ThemeColors = {
    primary: "#F07B43", // Es el color más representativo de tu marca o interfaz. Se usa para resaltar lo más importante: botones primarios, enlaces activos, íconos clave, etc.
    primaryHover: "#FFFAF7",    
    secondary: "#FCA422", // Color Pasivo - Un color complementario al primario, también usado para destacar elementos pero con menos jerarquía.
    secondaryHover: "#FFF5F0",
    tertiary:"#F49D73",
    tertiaryHover:"#FEEBE2",
    cuaternary: "#E46525",
    cuaternaryHover: "",  
    background: "#F5F6F7", // Es el color que define la superficie donde se colocan los elementos. Puede variar según el modo (claro/oscuro).
    backgroundSecondary: "#FFECEB",
    backgroundCuaternary: "#C3E7F2",
    backgroundQuinary: "#E3F4F9",
    backgroundSextary: "#232323",
    backgroundSeptary:"#EAFAF1",   
    backgroundOctary:"#E5F7ED",  
    backgroundNonary:"#E0EAFA",    

    text: "#1E2947", //Color principal del texto.
    textPill1:"#32945F",
    textPill2:"#F09713",
    textPill3:"#717883",
    textPill4:"#2664C7",
    white:"#FFFFFF",
    neutral:"#88919E",
    error: "#FF655A", // Para mensajes de estado o alertas.
    errorPasivo: "#FF655A",
    errorHover: "#F44336",
    informacion: "#2D94B4",

    Pasivo: "#FFFFFF",
    Hover: "#F7A43F",
    // Hover: "#79DD8B", //verde Hover
    Activo: "#F07B43",
    //Activo: "#42C67E",//verde
    //Gris
    Neutro: "#88919E",
    TitleGris: "#717883",
    GrisClaro: "#F5F6F7",
    //colores claros
    ClaroHover: "#FFFAF7",
    Claro: "#FFF5F0",
    //Alertas
    
    ErrorHoverClaro: "#FFECEB",
    Exito: "#42C67E",
    
    InformacionFondo: "#E3F4F9",
    //texto
    Title: "#E46525",
    TitleHover: "#FCA422",
    //lINEA
    lineaModal: "#F5A458",
    lineaTabla: "#FBD6C5",
    //circulos
    Circular: "#FEEBE2",
};

// Breakpoints globales para tu app (Material UI style)
export const breakpointsModel = {
  xs: 0, //xs (0–699 px): Teléfonos pequeños
  sm: 720, // sm (720–1279 px): Teléfonos grandes
  md: 1280, // md (1280–1919 px): Tablets y pantallas pequeñas
  lg: 1920, // lg (1920–2559 px): Laptops y monitores medianos
  xl: 2560, // xl (2560 px en adelante): Monitores grandes, pantallas 2K, etc.
};

// export const breakpointsModel = {
//     xs: 0, //xs (0–599 px): Teléfonos pequeños
//     sm: 600, // sm (600–899 px): Teléfonos grandes
//     md: 900, // md (900–1199 px): Tablets y pantallas pequeñas
//     lg: 1200, // lg (1200–1535 px): Laptops y monitores medianos
//     xl: 1536, // xl (1536 px en adelante): Monitores grandes, pantallas 2K, etc.
// };

export type Breakpoints = typeof breakpointsModel;
